<template>
  <div class="file-uploader">
    <input
      ref="fileInput"
      type="file"
      class="hidden"
      :accept="accept"
      @change="onFileChange"
      :multiple="multiple"
      aria-label="File upload"
    />
    <slot
      :triggerFileInput="triggerFileInput"
      :file="file"
      :preview="preview"
      :error="error"
      :removeFile="removeFile"
    ></slot>
  </div>
</template>

<script setup lang="ts">
  import { useFileUpload } from '@/composables/useFileUpload';

  const props = defineProps<{
    accept?: string;
    validationRules?: Array<{
      validate: (file: File) => boolean | Promise<boolean>;
      message: string;
    }>;
    currentPreview?: string;
    multiple?: boolean;
  }>();

  const emit = defineEmits<{
    (e: 'update:modelValue', file: File | null): void;
  }>();

  const {
    file,
    error,
    preview,
    fileInput,
    triggerFileInput,
    addFile,
    removeFile
  } = useFileUpload();

  if (props.currentPreview) {
    preview.value = props.currentPreview;
  }

  const onFileChange = async (event: Event) => {
    const newFile = (event.target as HTMLInputElement).files?.[0];
    if (newFile) {
      await addFile(newFile, props.validationRules ?? []);
      if (file.value) {
        emit('update:modelValue', file.value);
      }
    }
  };
</script>
